// extracted by mini-css-extract-plugin
export default {"container":"RMSHTMLBlock_container__ClINt","content":"RMSHTMLBlock_content__t2yTp"};